import { markRaw, defineAsyncComponent } from 'vue';
import type { DiscoveredRouteModule } from '@/router/generator/types';

// Local constants
const DirectoryView = () => import('@/views/DirectoryView.vue');
const DirectoryIndexView = () => import('@/views/directory/IndexView.vue');
const DirectoryProfileView = () => import('@/views/directory/ProfileView.vue');
const DirectorySearchView = () => import('@/views/directory/SearchView.vue');
const DirectoryExportView = () => import('@/views/directory/ExportView.vue');
export const NAME_DIRECTORY = 'Directory';
export const NAME_DIRECTORY_INDEX = 'DirectoryIndex';
export const NAME_DIRECTORY_PROFILE = 'DirectoryProfile';
export const NAME_DIRECTORY_SEARCH = 'DirectorySearch';
export const NAME_DIRECTORY_EXPORT = 'DirectoryExport';
export const NAME_DIRECTORY_TEST = 'DirectoryTest';
export const PATH_DIRECTORY = 'directory';

const DirectoryProfileHeaderComponent = defineAsyncComponent(() => import('@/components/app/directory/profile/HeaderComponent.vue'));
const DirectoryIndexHeaderComponent = defineAsyncComponent(() => import('@/components/app/directory/index/HeaderComponent.vue'));

// Environment-gated feature flag for AI Search
const isAISearchEnabled = (() => {
  const flag = (import.meta as any)?.env?.VITE_FEATURE_AI_SEARCH as unknown;
  if (typeof flag === 'boolean') return flag;
  if (typeof flag === 'string') return flag.toLowerCase() === 'true' || flag === '1';
  return (import.meta as any)?.env?.DEV === true;
})();

const baseChildren = [
  { path: '', component: DirectoryIndexView, name: NAME_DIRECTORY_INDEX, meta: { dynamicComponent: markRaw(DirectoryIndexHeaderComponent), dynamicComponentScale: 'scale-75', dataLoaders: ['project_document', 'project_user_fields', 'directory_default_perspective', 'project_groups'] } },
  { path: 'export', component: DirectoryExportView, name: NAME_DIRECTORY_EXPORT, meta: { requiresAuth: true, dataLoaders: ['directory_export'] } },
  { path: ':uid', component: DirectoryProfileView, name: NAME_DIRECTORY_PROFILE, meta: { dynamicComponent: markRaw(DirectoryProfileHeaderComponent), dynamicComponentScale: 'scale-75', dataLoaders: ['directory_profile', 'project_groups'] } },
];

const children = isAISearchEnabled
  ? [
      baseChildren[0],
      { path: 'search', component: DirectorySearchView, name: NAME_DIRECTORY_SEARCH, meta: { dataLoaders: ['project_document'] } },
      baseChildren[1],
      baseChildren[2],
    ]
  : baseChildren;

export const route: DiscoveredRouteModule = {
  id: 'app.directory.index',
  scope: 'app',
  moduleKey: 'directory',
  name: NAME_DIRECTORY,
  path: PATH_DIRECTORY,
  component: DirectoryView,
  meta: { dataLoaders: ['project_document', 'project_user_fields', 'directory_default_perspective', 'project_groups'] },
  requiresFeature: 'directory',
  children,
};


